exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-modal-open {\r\n  overflow: hidden;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n.vux-modal-open-for-container {\r\n  overflow: hidden!important;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vux/src/styles/vux-modal.css
// module id = 100
// module chunks = 1